module.exports = __webpack_public_path__ + "img/theme6.ca7e03ae.png";